const it = {
  nav: {
    home: 'Home',
    about: 'Chi siamo',
    solutions: 'Soluzioni',
    industries: 'Settori',
    contact: 'Contatti',
  },

  home: {
    phases: [
      {
        h1Before: 'Soluzioni ',
        h1Highlight: 'IT',
        h1After: ' su misura',
        h3: 'che crescono con la tua azienda',
        cols: [
          { border: 'l-blue', lines: ['Presenza', 'Digitale'] },
          { border: 'l-cyan', lines: ['Sviluppo', 'Applicazioni'] },
          { border: 'l-pink', lines: ['Integrazione', 'Enterprise'] },
        ],
      },
      {
        h1Before: 'La nostra ',
        h1Highlight: 'Proposta',
        h1After: ' di Valore',
        h3: 'che crescono con la tua azienda',
        cols: [
          { border: 'l-blue', lines: ['Ottimizzazione', 'dei Processi'] },
          { border: 'l-cyan', lines: ['Trasformazione', 'Digitale'] },
          { border: 'l-pink', lines: ['Decisioni', 'Data-Driven'] },
        ],
      },
      {
        h1Before: 'Allineamento ',
        h1Highlight: 'Strategico',
        h1After: ' Aziendale',
        h3: 'che crescono con la tua azienda',
        cols: [
          { border: 'l-blue', lines: ['Chiarezza', 'Strategica'] },
          { border: 'l-cyan', lines: ['Esecuzione', 'Esperta'] },
          { border: 'l-pink', lines: ['Partnership', 'Duratura'] },
        ],
      },
    ],
  },

  about: {
    slides: [
      {
        tag: 'Chi siamo',
        accent: 'var(--violet)',
        titleBefore: 'Chi ',
        titleHighlight: 'siamo',
        subtitle: 'Fondati nel 2018 con sede a Goslar, Germania — con team di sviluppo in Germania e India.',
        body: 'Costruiti per PMI e iniziative sociali, sfruttiamo la tecnologia come catalizzatore per una crescita sostenibile — colmando il divario tra grandi idee e le soluzioni digitali che le realizzano.',
        features: [
          { label: 'Fondati a Goslar, Germania — 2018' },
          { label: 'Team in Germania e India' },
          { label: 'Per PMI e Iniziative Sociali' },
        ],
        quoteBefore: 'Colmiamo il divario nell\'esecuzione digitale attraverso il Proxy Product Ownership, traducendo requisiti aziendali complessi in soluzioni digitali affidabili, scalabili e ad alte prestazioni.',
        quoteAuthor: 'Allineamento Strategico',
      },
      {
        tag: 'Chi siamo',
        accent: 'var(--cyan)',
        titleBefore: 'La nostra ',
        titleHighlight: 'Visione',
        subtitle: 'Potenziare le PMI attraverso la Trasformazione Digitale e l\'Innovazione.',
        body: 'In 7elemente, immaginiamo un futuro in cui le piccole e medie imprese raggiungono il loro massimo potenziale allineando le capacità digitali con la chiarezza strategica. Il nostro obiettivo è consentire alle PMI di operare al massimo della capacità.',
        features: [
          { label: 'Ispirare' },
          { label: 'Innovare' },
          { label: 'Impatto' },
        ],
        quoteBefore: 'La prossima generazione di leader di mercato non sarà definita dalle dimensioni — sarà definita da quanto bene usano la tecnologia.',
        quoteAuthor: 'La nostra Visione',
      },
      {
        tag: 'Chi siamo',
        accent: 'var(--highlight)',
        titleBefore: 'La nostra ',
        titleHighlight: 'Mission',
        subtitle: 'Co-creare soluzioni scalabili.',
        body: 'Co-creiamo soluzioni digitali che crescono con i nostri clienti — scalando con la loro capacità, allineate alle loro ambizioni e radicate nel valore a lungo termine. Attraverso design ponderato, sistemi intelligenti e partnership strategica, garantiamo un impatto duraturo.',
        features: [
          { label: 'Chiarezza Strategica' },
          { label: 'Esecuzione Esperta' },
          { label: 'Partner di Fiducia' },
        ],
        quoteBefore: 'Tu concentrati sui tuoi obiettivi aziendali — noi saremo la tua ala IT.',
        quoteAuthor: 'La nostra Mission',
      },
    ],
  },

  solutions: {
    slides: [
      {
        tag: 'Soluzione',
        accent: 'var(--violet)',
        video: 'digexp',
        titleBefore: 'Presenza ',
        titleHighlight: 'Digitale',
        subtitle: 'La tua presenza online non è solo un sito web — è la tua stretta di mano digitale.',
        body: 'Creiamo esperienze digitali senza interruzioni che fondono design, tecnologia e performance. Da siti web visivamente sorprendenti a piattaforme ottimizzate per le prestazioni, ti aiutiamo a guadagnare visibilità, promuovere il coinvolgimento e crescere con scopo.',
        features: [
          { label: 'Web Design Responsive' },
          { label: 'SEO & Performance' },
          { label: 'Trasformazione Digitale' },
        ],
        quoteBefore: 'Il tuo sito web è il tuo miglior venditore — lavora tutto il giorno, raggiunge chiunque, ovunque.',
        quoteAuthor: 'Digital First',
      },
      {
        tag: 'Soluzione',
        accent: 'var(--cyan)',
        video: 'appeng',
        titleBefore: 'Ingegneria delle ',
        titleHighlight: 'Applicazioni',
        subtitle: 'Dalle interfacce ai sistemi backend enterprise — sviluppiamo tutto.',
        body: 'Dalle startup ai prodotti in crescita e alla modernizzazione dei sistemi legacy, trasformiamo le idee in potenti prodotti digitali — combinando design ponderato con tecnologia scalabile e senza interruzioni.',
        features: [
          { label: 'Applicazioni Web Personalizzate' },
          { label: 'Sviluppo App Mobile' },
          { label: 'Automazione dei Workflow' },
        ],
        quoteBefore: 'Il buon software non riguarda la scrittura di codice — riguarda la risoluzione dei problemi giusti nel modo più semplice possibile.',
        quoteAuthor: 'Mentalità Ingegneristica',
      },
      {
        tag: 'Soluzione',
        accent: 'var(--highlight)',
        video: 'entint',
        titleBefore: 'Intelligenza ',
        titleHighlight: 'Enterprise',
        subtitle: 'Dalla strategia al cloud, dai dati ai processi — aiutiamo le imprese a evolversi.',
        body: 'In 7element, aiutiamo le imprese del retail e della produzione a ottimizzare le operazioni, unificare le esperienze digitali e fisiche, e scalare con fiducia. Dal commercio connesso all\'integrazione ERP e PIM.',
        features: [
          { label: 'Soluzioni PIM' },
          { label: 'Infrastruttura Cloud' },
          { label: 'Integrazione di Sistemi' },
        ],
        quoteBefore: 'L\'integrazione non è una sfida tecnica — è una sfida strategica. I sistemi connessi creano organizzazioni connesse.',
        quoteAuthor: 'Strategia Enterprise',
      },
    ],
  },

  industries: {
    slides: [
      {
        tag: 'Settore',
        accent: 'var(--violet)',
        video: 'manufacturing',
        title: 'Retail & Produzione',
        subtitle: 'Digitalizzare i percorsi del retail e modernizzare i processi produttivi.',
        body: 'In 7element, aiutiamo le imprese del retail e della produzione a ottimizzare le operazioni, unificare le esperienze digitali e fisiche, e scalare con fiducia. Dal commercio connesso all\'integrazione ERP e PIM, riduciamo le frizioni e guidiamo l\'eccellenza operativa.',
        features: [
          { label: 'Gestione delle Informazioni di Prodotto (PIM)' },
          { label: 'E-Commerce & Presenza Online' },
          { label: 'Operazioni & Integrazione della Supply Chain' },
        ],
        quoteBefore: 'I sistemi disconnessi creano esperienze disconnesse. Uniamo tutto — in modo intelligente, senza interruzioni e su scala.',
        quoteAuthor: 'Retail & Produzione',
      },
      {
        tag: 'Settore',
        accent: 'var(--cyan)',
        video: 'education',
        title: 'Istruzione & Formazione',
        subtitle: 'Potenziare l\'apprendimento attraverso l\'innovazione digitale.',
        body: 'Nel panorama educativo in evoluzione, la trasformazione digitale migliora l\'apprendimento, ottimizza l\'amministrazione ed espande l\'accesso. Aiutiamo le istituzioni a offrire esperienze di apprendimento personalizzate, scalabili e coinvolgenti.',
        features: [
          { label: 'Sviluppo di Piattaforme E-Learning' },
          { label: 'Gestione di Contenuti e Corsi' },
          { label: 'Ingegneria di Applicazioni EdTech' },
        ],
        quoteBefore: 'L\'istruzione si sta evolvendo, e così dovrebbero i suoi strumenti. Abbracciare la trasformazione digitale non è solo un\'opzione — è una necessità per un apprendimento orientato al futuro.',
        quoteAuthor: 'Istruzione & Formazione',
      },
      {
        tag: 'Settore',
        accent: 'var(--highlight)',
        video: 'dna',
        title: 'Salute & Benessere',
        subtitle: 'Soluzioni di salute digitale sicure, connesse e centrate sull\'uomo.',
        body: 'La trasformazione digitale sta rimodellando la sanità migliorando la cura del paziente, ottimizzando le operazioni e garantendo la conformità. Costruiamo sistemi sicuri e scalabili che consentono esperienze di cura personalizzate.',
        features: [
          { label: 'Applicazioni Web per Pazienti' },
          { label: 'Gestione Dati conforme al GDPR' },
          { label: 'Automazione di Prenotazioni e Workflow' },
        ],
        quoteBefore: 'In sanità, ogni dato rappresenta una vita. Garantire un flusso di informazioni fluido, sicuro e accessibile non è solo una necessità tecnica — è un imperativo morale.',
        quoteAuthor: 'Salute & Benessere',
      },
    ],
  },

  contact: {
    navContact: 'Contatti',
    navImpression: 'Note Legali',
    tag: 'Mettiti in Contatto',
    heading: 'Contatti',
    headingHighlight: '',
    intro: 'Che tu stia partendo da zero o scalando, ci piacerebbe sentire parlare dei tuoi obiettivi. Contattaci e uno dei nostri esperti ti risponderà entro 24 ore.',
    addressLabel: 'Indirizzo',
    emailLabel: 'Email',
    phoneLabel: 'Telefono',
    form: {
      namePlaceholder: 'Il tuo nome',
      emailPlaceholder: 'tua@email.com',
      companyPlaceholder: 'Nome della tua azienda',
      messagePlaceholder: 'Raccontaci del tuo progetto...',
      nameLabel: 'Nome',
      emailLabel: 'Email',
      companyLabel: 'Azienda',
      messageLabel: 'Messaggio',
      submit: 'Invia Messaggio',
      sending: 'Invio in corso…',
    },
    successHeading: 'Messaggio inviato!',
    successBody: 'Ti risponderemo entro 24 ore.',
    errorMsg: 'Qualcosa è andato storto. Riprova o scrivici direttamente.',
    impression: {
      tag: 'Legale',
      titleBefore: 'Note ',
      titleHighlight: 'Legali',
      subtitle: '7Elemente IT-Solutions UG (haftungsbeschränkt)',
      body: 'Ai sensi del § 5 TMG (Telemediengesetz). Questo sito è gestito da 7Elemente IT-Solutions UG. Tutti i contenuti sono soggetti alla legge tedesca sul diritto d\'autore.',
      features: [
        { label: 'Bahnhofstraße 11, 38642 Goslar, Germania' },
        { label: 'Email: info@7Elemente.com' },
        { label: 'Telefono: +49 5321 39 49 49 6' },
        { label: 'Registro: Amtsgericht Braunschweig' },
      ],
      quoteBefore: 'La trasparenza non è solo un obbligo legale — è il riflesso di come facciamo business.',
      quoteAuthor: 'Note Legali',
    },
  },

  mitra: {
    slides: [
      {
        letter: 'M',
        tag: 'I nostri Valori',
        titleBefore: '',
        titleHighlight: 'Maestria',
        subtitle: '15+ anni di eccellenza IT enterprise.',
        body: 'Portiamo una profonda competenza in SAP, Microsoft Dynamics, infrastruttura cloud e sviluppo web moderno — acquisita attraverso la consegna reale di progetti enterprise, non dalla teoria.',
        features: [
          { label: 'Architettura Enterprise' },
          { label: 'Competenza Cross-Domain' },
          { label: 'Consegna Comprovata' },
        ],
        accent: 'var(--violet)',
        quote: 'L\'eccellenza non è un\'abilità — è un\'abitudine costruita nel corso di anni di risoluzione dei problemi che altri non potevano.',
      },
      {
        letter: 'I',
        tag: 'I nostri Valori',
        titleBefore: '',
        titleHighlight: 'Integrità',
        subtitle: 'Consegna trasparente, ogni passo del percorso.',
        body: 'Crediamo nella comunicazione onesta, nelle tempistiche realistiche e senza costi nascosti. I nostri clienti sanno sempre dove si trova il loro progetto — e perché.',
        features: [
          { label: 'Prezzi Trasparenti' },
          { label: 'Tempistiche Oneste' },
          { label: 'Comunicazione Chiara' },
        ],
        accent: 'var(--cyan)',
        quote: 'Il fondamento di ogni grande partnership è la fiducia — e la fiducia si costruisce attraverso la trasparenza.',
      },
      {
        letter: 'T',
        tag: 'I nostri Valori',
        titleBefore: '',
        titleHighlight: 'Talento',
        subtitle: 'Una rete curata di professionisti esperti.',
        body: 'Selezioniamo specialisti dalla nostra rete di ingegneri senior, designer e strateghi — assemblando il team giusto per ogni sfida unica.',
        features: [
          { label: 'Rete Solo Senior' },
          { label: 'Specialisti di Dominio' },
          { label: 'Team Agili' },
        ],
        accent: 'var(--highlight)',
        quote: 'I grandi prodotti non sono costruiti da grandi aziende — sono costruiti da grandi persone.',
      },
      {
        letter: 'R',
        tag: 'I nostri Valori',
        titleBefore: '',
        titleHighlight: 'Affidabilità',
        subtitle: 'Nei tempi, nel budget — ogni volta.',
        body: 'Stabiliamo aspettative realistiche e le manteniamo. Il nostro approccio strutturato alla gestione dei progetti garantisce una qualità costante dal kickoff al lancio.',
        features: [
          { label: 'Consegna per Milestone' },
          { label: 'Garanzia di Qualità' },
          { label: 'Supporto Post-Lancio' },
        ],
        accent: 'var(--violet)',
        quote: 'L\'affidabilità non riguarda l\'essere perfetti — riguarda l\'essere affidabili quando conta di più.',
      },
      {
        letter: 'A',
        tag: 'I nostri Valori',
        titleBefore: '',
        titleHighlight: 'Adattabilità',
        subtitle: 'Agile, a prova di futuro e in continua evoluzione.',
        body: 'La tecnologia cambia velocemente. Restiamo all\'avanguardia — adottando nuovi strumenti, framework e metodologie per garantire che le tue soluzioni rimangano competitive per anni.',
        features: [
          { label: 'Metodologia Agile' },
          { label: 'Architettura a Prova di Futuro' },
          { label: 'Innovazione Continua' },
        ],
        accent: 'var(--cyan)',
        quote: 'Le aziende che prosperano non sono le più forti — sono quelle più reattive al cambiamento.',
      },
    ],
  },
};

export default it;
